export const MESSAGE_ROLES = {
  USER: "user",
  ASSISTANT: "assistant",
}

export const ERROR_CODES = {
  CHAT_CONTINUE_THREAD_WITH_MESSAGE_CONFLICT: "CHAT_CONTINUE_THREAD_WITH_MESSAGE_CONFLICT",
}

export const MAX_TABLE_PREVIEW_ROWS = 3
